module.exports = __webpack_public_path__ + "static/media/app_store.d37be22b.png";